import Vue from 'vue'
import moment from 'moment'

Vue.filter('rowsPerPage', function (total, perPage) {
  if (total % perPage === 0) {
    return total / perPage
  } else {
    return (total / perPage) + 1
  }
})

Vue.filter('dateTimeFormat', function (value) {
  if (!value) return ''
  return moment(value).format('MM/DD/YYYY hh:mm A')
})

Vue.filter('dateTimeFormatShortYear', function (value) {
  if (!value) return ''
  return moment(value).format('MM/DD/YY hh:mm A')
})

Vue.filter('dateFormat', function (value) {
  if (!value) return ''
  return moment(value).format('MM/DD/YYYY')
})

Vue.filter('timeFormat', function (value, showSeconds = false) {
  if (!value) return ''
  if (showSeconds) {
    return moment(value).format('hh:mm:ss A')
  }
  return moment(value).format('hh:mm A')
})

Vue.filter('formatNumber', function (value) {
  if (typeof value !== 'number') {
    value = parseInt(value)
  }
  return value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
})

Vue.filter('phoneNumber', function (phone) {
  if (!phone) return ''
  return phone.replace(/[^0-9]/g, '')
    .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
})

Vue.filter('toAgo', function (value) {
  if (!value) return ''
  return moment(value).fromNow()
})

Vue.filter('isPastDate', function (value) {
  const _date = new Date(value)
  const _dateNow = new Date(Date())
  const _utc = Date.UTC(_date.getUTCFullYear(), _date.getUTCMonth(), _date.getUTCDate(), _date.getUTCHours(), _date.getUTCMinutes(), _date.getUTCSeconds())
  const _utcNow = Date.UTC(_dateNow.getUTCFullYear(), _dateNow.getUTCMonth(), _dateNow.getUTCDate(), _dateNow.getUTCHours(), _dateNow.getUTCMinutes(), _dateNow.getUTCSeconds())

  const isToday = _date.setHours(0, 0, 0, 0) === _dateNow.setHours(0, 0, 0, 0)

  return _utc < _utcNow && !isToday
})

Vue.filter('hoursToDateHours', function (value) {
  if (value <= 24) {
    let val = `${value} hour`
    if (value > 1) {
      val += 's'
    }

    return val
  }

  let str = ''
  let days = value / 24

  days = days < 1 ? 0 : days.toFixed(0)
  let hours = value % 24

  if (days !== 0) {
    str = `${days} day`

    if (days > 1) {
      str += 's'
    }
  }

  if (hours > 0) {
    if (str !== '') {
      str += ' '
    }
    str += `${hours} hour`

    if (hours > 1) {
      str += 's'
    }
  }

  return str
})

Vue.filter('reportsCurrency', function (value) {
  return '$' + Vue.filter('currency')(value, '', 2)
  // $options.filters.currency(props.item.parking_fee, '', 2)
})

Vue.filter('calcExpiredTime', function (value) {
  if (!value.end_datetime || !value.actual_datetime) return ''

  let timeType
  let dateNow = moment(value.actual_datetime)
  let itemDate = moment(value.end_datetime)

  let diff = moment.duration(itemDate.diff(dateNow))
  let positiveDiff = Math.abs(diff._milliseconds)
  let stat = diff._milliseconds

  if (((positiveDiff) / (1000)) < 3600) {
    timeType = 'Minutes'
    diff = diff.asMinutes()
  } else if ((positiveDiff / (1000 * 3600)) < 24) {
    timeType = 'Hours'
    diff = diff.asHours()
  } else if ((positiveDiff) / (1000 * 3600 * 24) < 30) {
    timeType = 'Days'
    diff = diff.asDays()
  } else {
    timeType = 'Months'
    diff = diff.asMonths()
  }

  diff = Math.floor(Math.abs(diff))

  if (diff === 1) {
    timeType = timeType.slice(0, -1)
  }

  if (!value.status) {
    if (stat < 0) {
      return 'Expired ' + diff + ' ' + timeType + ' Ago'
    } else {
      return 'Expired'
    }
  } else {
    return 'Expires in ' + diff + ' ' + timeType
  }
})



// WEBPACK FOOTER //
// ./src/helpers/filters/index.js